import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILandingPage } from './landing-page.model';
import { createRequestOption } from '../../../shared-libs/util/request-util';
import { environment } from '../../../../../environments/environment';
import { ProfileService } from '../../../shared-libs/service/profile.service';


type EntityResponseType = HttpResponse<ILandingPage>;
type EntityArrayResponseType = HttpResponse<ILandingPage[]>;

@Injectable({ providedIn: 'root' })
export class LandingPageService {
  public resourceUrl = environment.SERVER_API_URL + 'services/configurator/api/landing-pages';

  constructor(protected http: HttpClient,
    protected profileService: ProfileService) {}

  private getHeader(): HttpHeaders{
    let headers = new HttpHeaders();
    headers = headers.set('X-DataStoreID', String(this.profileService.getDatastore()));
    return headers;
  }

  create(landingPage: ILandingPage): Observable<EntityResponseType> {
    return this.http.post<ILandingPage>(this.resourceUrl, landingPage, { observe: 'response', headers: this.getHeader() });
  }

  update(landingPage: ILandingPage): Observable<EntityResponseType> {
    return this.http.put<ILandingPage>(this.resourceUrl, landingPage, { observe: 'response', headers: this.getHeader() });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ILandingPage>(`${this.resourceUrl}/${id}`, { observe: 'response', headers: this.getHeader() });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ILandingPage[]>(this.resourceUrl, { params: options, observe: 'response', headers: this.getHeader() });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response', headers: this.getHeader() });
  }

  getData(codeLandingpage: string, lang: string, action: string = "init", data: string = null):  Observable<any> {
    let params: any = {
      codeLandingpage: codeLandingpage,
      action: action,
      lang: lang
    }
    if (data) {
      params.data = data;
    }
    return this.http.get(environment.SERVER_API_URL +`services/engine/api/public/v1/landingpage/ihm/data`, { params: params, headers: this.getHeader() });
  }
}
